import { Alert, Button, Group, Modal, Stack, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { CommunicationBypassPrefix } from "../../../services/admin/communicationSettings.service";
import BypassPrefixChangeList from "./BypassPrefixChangeList";

interface ConfirmBypassPrefixChangesModalProps {
  opened: boolean;
  additions: CommunicationBypassPrefix[];
  removals: CommunicationBypassPrefix[];
  isSaving: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ConfirmBypassPrefixChangesModal({
  opened,
  additions,
  removals,
  isSaving,
  onClose,
  onConfirm,
}: ConfirmBypassPrefixChangesModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Confirm live communication prefixes"
      centered
      closeOnClickOutside={!isSaving}
      closeOnEscape={!isSaving}
    >
      <Stack gap="md">
        <Alert
          icon={<IconAlertTriangle size={18} />}
          color="orange"
          variant="light"
          title="This changes live delivery routing"
        >
          Selected prefixes may send email and fax communications to their
          intended recipients while redirect safeguards remain enabled.
        </Alert>
        <BypassPrefixChangeList
          label="Add"
          prefixes={additions}
          color="green"
          emptyLabel="No additions"
        />
        <BypassPrefixChangeList
          label="Remove"
          prefixes={removals}
          color="red"
          emptyLabel="No removals"
        />
        <Text size="sm" c="dimmed">
          The new set is evaluated when each communication is sent or retried.
        </Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose} disabled={isSaving}>
            Continue editing
          </Button>
          <Button color="orange" onClick={onConfirm} loading={isSaving}>
            Confirm and save
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
